var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00037 4.5C2.00037 3.70435 2.31644 2.94129 2.87905 2.37868C3.44166 1.81607 4.20472 1.5 5.00037 1.5H14.0004C14.796 1.5 15.5591 1.81607 16.1217 2.37868C16.6843 2.94129 17.0004 3.70435 17.0004 4.5V13.5C17.0004 14.2956 16.6843 15.0587 16.1217 15.6213C15.5591 16.1839 14.796 16.5 14.0004 16.5H5.00037C4.20472 16.5 3.44166 16.1839 2.87905 15.6213C2.31644 15.0587 2.00037 14.2956 2.00037 13.5V4.5Z",
    stroke: "#72767D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87537 8.25C7.9109 8.25 8.75037 7.41053 8.75037 6.375C8.75037 5.33947 7.9109 4.5 6.87537 4.5C5.83983 4.5 5.00037 5.33947 5.00037 6.375C5.00037 7.41053 5.83983 8.25 6.87537 8.25Z",
    stroke: "#72767D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3949 9.46548L5.00037 16.4997H14.1001C14.8693 16.4997 15.607 16.1942 16.1509 15.6503C16.6948 15.1064 17.0004 14.3687 17.0004 13.5995V13.4997C17.0004 13.1502 16.8691 13.016 16.6329 12.7572L13.6104 9.46098C13.4695 9.30732 13.2981 9.18471 13.1072 9.10096C12.9163 9.01722 12.7101 8.97419 12.5016 8.97461C12.2932 8.97504 12.0871 9.01891 11.8965 9.10342C11.706 9.18794 11.5351 9.31125 11.3949 9.46548V9.46548Z",
    stroke: "#72767D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.e6cc2574af0895c166192880d8b4e4cc.svg";
export { ForwardRef as ReactComponent };